import { useState } from 'react';
import { requestOtp } from '../api/authApi';
import {showError} from "../../../utils/toastHelper";

export const useLogin = () => {
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);

    const login = async (mobile, reagentCode = null) => {
        try {
            setLoading(true);
            setError(null);
            const data = await requestOtp(mobile, reagentCode);

            return {
                success: true,
                data
            }
        } catch (err) {
            showError(err?.response?.data?.message);
            setError(err?.response?.data?.message || 'خطا در ارسال درخواست');
        } finally {
            setLoading(false);
        }
    };

    return { login, loading, error };
};
